<section class="card carrito-card position-relative">
  <button class="btn btn-link text-danger position-absolute top-0 end-0 m-2 p-0 small cerrar-sesion"
    (click)="cerrarSesion()" title="Cerrar sesión">
    Cerrar Sessión <i class="fa fa-sign-out-alt"></i>
  </button>

  <h2 class="mb-3">
    <i class="icono">🛒</i> Carrito Actual
  </h2>

  <ng-container *ngIf="items.length > 0; else sinCarrito">
    <ul class="item-list">
      <li *ngFor="let item of items">
        <div class="nombre">{{ item.mercaderia.nombre }}</div>
        <div class="detalle">x{{ item.cantidad }} - ${{ item.precio * cotizacion }}</div>
      </li>
    </ul>

    <p class="total"><strong>Total: ${{ calcularTotal() * cotizacion }}</strong></p>

    <!-- 🟢 NUEVO BLOQUE: Continuar con la compra -->
    <div class="continuar-compra-confirm mt-4 text-center p-4 bg-success bg-opacity-10 border border-success rounded-4">
      <i class="fa fa-credit-card fa-2x text-success mb-2"></i>
      <h5 class="fw-semibold mb-2">¿Listo para confirmar tu pedido?</h5>
      <p class="text-muted mb-3 small">
        Revisá tu carrito y completá la compra en el siguiente paso.
      </p>
      <a routerLink="/confirm" class="btn btn-success btn-lg rounded-pill px-4">
        <i class="fa fa-check-circle me-2"></i> Continuar con la compra
      </a>
    </div>


  </ng-container>
  <!-- Bloque visual de continuar compra -->
  <div class="continuar-compra mt-4 text-center p-4 bg-light rounded-4 border border-1 border-opacity-25">
    <div class="mb-3">
      <i class="fa fa-shopping-bag fa-2x text-success mb-2"></i>
      <h5 class="mb-1 fw-semibold">¿Querés seguir explorando?</h5>
      <p class="text-muted mb-3 small">
        Descubrí más productos y completá tu compra con lo que te falta.
      </p>
      <a routerLink="/" class="btn btn-outline-success btn-lg rounded-pill px-4">
        <i class="fa fa-store me-2"></i> Seguir comprando
      </a>
    </div>
  </div>
  <ng-template #sinCarrito>
    <div class="sin-carrito">
      <p><i class="icono">🛍️</i> No hay productos en tu carrito.</p>
    </div>
  </ng-template>
</section>

<section class="card historial">
  <h2><i class="icono">📦</i> Mis Compras</h2>

  <div *ngFor="let compra of historial" class="compra-item">
    <span *ngIf="compra.estado == 'pedida'" class="btn-eliminar" title="Cancelar pedido"
      (click)="eliminarCompra(compra)">
      <i class="fa fa-trash"></i>
    </span>

    <h3>
      <span class="fecha">{{ compra.created_at | date:'dd-MM-yyyy' }}</span>
      <span class="me-3 estado estado-{{ compra.estado }}">{{ compra.estado }}</span>
    </h3>

    <p>
      <strong>{{ compra.cliente }}</strong> -
      {{ compra.condicion | titlecase }} - ${{ compra.total }}
    </p>
    <p class="descripcion">{{ compra.descripcion }}</p>
  </div>

  <ng-template #sinCompras>
    <div class="sin-carrito">
      <p><i class="icono">📭</i> Aún no realizaste compras.</p>
    </div>
  </ng-template>
</section>